import { ChangeDetectionStrategy, Component, contentChild, model, TemplateRef } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";
import { ButtonModule, CheckboxModule, DividerModule, IconModule } from "@jack-sparrow-libraries/ui-kit";
import { CommonModule } from "@angular/common";

/**
 * Composant de liste d'accordéon avec cases à cocher.
 * @description Permet de sélectionner plusieurs éléments dans une liste avec un mécanisme de sélection globale.
 */
@Component({
	selector: "cba-accordion",
	templateUrl: "accordion.component.html",
	styleUrl: "accordion.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CheckboxModule, ButtonModule, DividerModule, IconModule, CommonModule],
	animations: [
		trigger("expandCollapse", [
			transition(":enter", [
				style({ transform: "scaleY(1)", height: "0px" }),
				animate("300ms cubic-bezier(0.4, 0, 0.27, 1)", style({ transform: "scaleY(1)", height: "*" })),
			]),
			transition(":leave", [
				style({ transform: "scaleY(1)", height: "*" }),
				animate("300ms cubic-bezier(0.4, 0, 0.27, 1)", style({ transform: "scaleY(1)", height: "0px" })),
			]),
		]),
	],
})
export class AccordionComponent {
	// --- Inputs ---
	/**
	 * État d'expansion de l'accordéon (ouvert ou fermé)
	 * @type {boolean}
	 * @default false
	 */
	readonly $expanded = model(false, { alias: "expanded" });

	// -- Content children ---
	protected readonly $headerTemplate = contentChild<TemplateRef<unknown>>("header");
	protected readonly $contentTemplate = contentChild<TemplateRef<unknown>>("content");
}
